/**
 * Created by mateimisarca on 21/09/2020
 */

const noop = () => {};

export default noop;
